import { Fragment, useEffect, useState } from 'react'
import { useTranslation } from 'react-i18next'
import { Box } from '@mui/material'
import { PageTitle } from '../components/atoms/PageTitle'
import { callAxios } from '../hooks/useAxios'
import { User } from '../types/models'
import { usorter } from '../utils/sorter'
import { UserDataTable } from '../components/UserDataTable'

export function AdminUsersPage(): React.ReactElement {

  const [users, setUsers] = useState<User[]>([])
  const { t } = useTranslation()

  const updateUsers = () => {
    callAxios<User[]>({
      url: '/users',
    }).then(res => res.success && setUsers(usorter(res.data, 'email')))
  }

  // eslint-disable-next-line react-hooks/exhaustive-deps
  useEffect(() => updateUsers(), [])

  return (
    <Fragment>
      <PageTitle title={t('Users')}/>
      <Box sx={{ mt: 2, position: 'relative' }}>
        <UserDataTable users={users}/>
      </Box>
    </Fragment>
  )
}
